import { Link } from 'react-router-dom';
import { Button, Dimmer, Header, Loader, Statistic } from 'semantic-ui-react';
import ClientUsersList from './ClientUsersList';
import useClientDetails from '../../hooks/useClientDetails';
import { useState } from 'react';
import AddUserToGroup from '../ClientGroups/AddUserToGroup';
import RemoveUserFromGroup from '../ClientGroups/RemoveUserFromGroup';

const ClientUsers = ({ users, clientId: id }: any) => {
  // const { users, isLoading } = useClientUsers(id);

  const { clients } = useClientDetails(id);

  const [addUserToGroup, setAddUserToGroup] = useState(false);
  const [removeUserFromGroup, setRemoveUserFromGroup] = useState(false);

  const client = clients[id];

  return (
    <div>
      {addUserToGroup && (
        <AddUserToGroup setAddUserToGroup={setAddUserToGroup} id={id} />
      )}
      {removeUserFromGroup && (
        <RemoveUserFromGroup
          setRemoveUserFromGroup={setRemoveUserFromGroup}
          id={id}
        />
      )}
      <Header>Users</Header>
      {!users ? (
        <Dimmer active>
          <Loader />
        </Dimmer>
      ) : (
        <div>
          <Statistic.Group>
            <Statistic>
              <Statistic.Value>
                {users.filter((user) => user.IsActive).length}
              </Statistic.Value>
              <Statistic.Label>Active</Statistic.Label>
            </Statistic>
            <Statistic>
              <Statistic.Value>{users.length}</Statistic.Value>
              <Statistic.Label>Total</Statistic.Label>
            </Statistic>
          </Statistic.Group>
          <Button as={Link} to={`/clients/users/add/${id}`}>
            Add
          </Button>
          {client.GroupId && (
            <>
              <Button
                onClick={() => {
                  setAddUserToGroup((val) => !val);
                }}
              >
                Add User From Group
              </Button>
              <Button
                onClick={() => {
                  setRemoveUserFromGroup((val) => !val);
                }}
              >
                Remove User From Group
              </Button>
            </>
          )}
          <br />
          <ClientUsersList users={users} />
        </div>
      )}
    </div>
  );
};

export default ClientUsers;
